import { Reference } from '@commercetools/platform-sdk';

import { productProjectionFragment } from '@/graphql/fragments/productProjection';
import { BaseProductProjectionResult } from '@/utils/productProjection';

export interface Variables {
  limit?: number;
  locale?: string;
  tagFilters: string;
}

export type ProductsByTagsProjectionResult = BaseProductProjectionResult & {
  masterVariant: {
    attributesRaw: [
      {
        name: 'tagReferences';
        value: Reference[];
      },
    ];
  };
};

export interface ProductsByTagsProjectionSearchResponse {
  data: {
    productProjectionSearch: {
      results: ProductsByTagsProjectionResult[];
    };
  };
}

export const ProductsByTags = `
query ProductsByTags($tagFilters: String!, $locale: Locale = "en", $limit: Int = 500) {
  productProjectionSearch(
    filters: [
      { string: $tagFilters },
    ],
    limit: $limit,
  ) {
    results {
      ...productProjectionFragment

      masterVariant {
        attributesRaw(includeNames: ["tagReferences"]) {
          name
          value
        }
      }
    }
  }
}

${productProjectionFragment}
`;
